import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import firebase from "firebase/app";
import "firebase/analytics";

import "./scss/index.scss";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDDjeeBKNPBORl2JHG0Vr-WY2yoETExe80",
  authDomain: "edgar-dias-4dbbf.firebaseapp.com",
  databaseURL: "https://edgar-dias-4dbbf.firebaseio.com",
  projectId: "edgar-dias-4dbbf",
  storageBucket: "edgar-dias-4dbbf.appspot.com",
  messagingSenderId: "584720431153",
  appId: "1:584720431153:web:57a9dfa12248b64bd9bd10",
  measurementId: "G-W8EG3LLJPQ",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
